import React, {useEffect} from 'react';
import '../../App.css';
import Footer from '../Footer';
import HomeGallery from '../HomeGallery';


function PortfolioCar() {
    useEffect(() => {
        const timer = setTimeout(() => {
            window.scrollTo({ top: window.innerHeight * 0.75, behavior: 'smooth' });
            }, 50);

        return () => clearTimeout(timer);
    }, []);
    
    return (
    <>
        <h1 className='portfolio-hero'>Portfolio</h1>

        <h1 className='text'>Car Portraits</h1>

        <HomeGallery images={[
            '/images/img-car-5.jpg',
            '/images/img-car-6.jpg',
            '/images/img-car-10.jpg',
            '/images/img-car-7.jpg',
            '/images/img-car-9.jpg',
            '/images/img-car-8.jpg',
            '/images/img-car-44.jpg',
            '/images/img-car-43.jpg',
            '/images/img-car-30.jpg',
            '/images/img-car-29.jpg',
            '/images/img-car-28.jpg',
            '/images/img-car-27.jpg',
            '/images/img-car-41.jpg',
            '/images/img-car-42.jpg',
            '/images/img-car-46.jpg',
            '/images/img-car-45.jpg',
            '/images/img-car-22.jpg',
            '/images/img-car-23.jpg',
            '/images/img-car-13.jpg',
            '/images/img-car-12.jpg',
            '/images/img-car-20.jpg',
            '/images/img-car-21.jpg',
            '/images/img-car-16.jpg',
            '/images/img-car-17.jpg',
            '/images/img-car-24.jpg',
            '/images/img-car-25.jpg',
            '/images/img-car-32.jpg',
            '/images/img-car-33.jpg',
            '/images/img-car-34.jpg',
            '/images/img-car-35.jpg',
            '/images/img-car-31.jpg',
            '/images/img-car-36.jpg',
            '/images/img-car-38.jpg',
            '/images/img-car-37.jpg'
        ]} />
        <Footer />
    </>
  )
}

export default PortfolioCar
